export default {
    methods: {
        displayPricing(min, max) {

            // check if the same price
            if (min === max) {
                return `${min}`;
            }

            return `${min} - ${max}`;
        }
    }
};